import { Chip, InputLabel, useTheme } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useRef, useState } from 'react'

export const ChipInput = ({ value, onChange, label, max = 0, prefix = '' }) => {
  const input = useRef(null)
  const span = useRef(null)
  const [inputValue, setInputValue] = useState('')
  const [width, setWidth] = useState(0)
  const theme = useTheme()
  const disabled = max !== 0 && value.length >= max

  useEffect(() => {
    setWidth(span.current?.offsetWidth + 10)
  }, [inputValue])

  const addChip = chip => {
    const prefixed = chip.indexOf(prefix) === -1 ? `${prefix}${chip}` : chip
    setInputValue('')
    if (disabled) {
      return
    }
    if (value.indexOf(prefixed) === -1 && chip?.trim() !== '') {
      onChange([...value, prefixed])
    }
  }

  const deleteChip = index => {
    const newValue = [...value]
    const deleted = newValue.splice(index, 1)
    if (deleted) {
      onChange(newValue)
    }
  }

  const handleChange = e => {
    setInputValue(e.target.value)
  }

  const onBlur = e => {
    addChip(e.target.value)
  }

  const handleKeyDown = e => {
    if (e.code === 'Enter' || e.code === 'Space') {
      e.preventDefault()
      addChip(e.target.value)
    }
  }

  return (
    <Box
      onClick={() => input.current?.focus()}
      sx={{
        display: 'flex',
        flexFlow: 'row wrap',
        maxHeight: 'none',
        height: 'auto',
        minHeight: 40,
        width: '100%',
        padding: '8px',
        position: 'relative',
        border: `1px solid ${theme.palette.grey[400]}`,
        borderRadius: '4px',
        '&:hover': {
          border: `1px solid ${theme.palette.grey[600]}`
        }
      }}
    >
      <InputLabel sx={{ backgroundColor: '#FFF', padding: '0 8px' }} shrink>
        {label}
      </InputLabel>
      <>
        {value?.map((item, index) => (
          <Chip
            sx={{ marginRight: '4px', marginTop: '4px' }}
            key={item}
            tabIndex={-1}
            label={item}
            variant='filled'
            size='small'
            onDelete={() => deleteChip(index)}
          />
        ))}
      </>
      <span ref={span} style={{ position: 'absolute', opacity: 0, zIndex: -1 }}>
        {inputValue}
      </span>
      <input
        onKeyDown={handleKeyDown}
        ref={input}
        size=''
        disabled={disabled}
        style={{
          border: 'none',
          outline: 'none',
          width: width,
          minWidth: 20,
          fontSize: '16px',
          backgroundColor: 'transparent'
        }}
        onChange={handleChange}
        value={inputValue}
        onBlur={onBlur}
      />
    </Box>
  )
}
